const DocMenuConfig = [
  {
    pages: [
      // 1. 数据统计 - 高频，置顶
      {
        heading: "dashboard",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/graphs/gra001.svg",
        fontIcon: "bi-bar-chart-line",
        roles: ['admin', 'operation', 'goods'],
      },

      // 2. 抽赏中心 - 核心业务
      {
        sectionTitle: "lottery_center",
        route: "/lottery",
        svgIcon: "media/icons/duotune/ecommerce/ecm004.svg",
        fontIcon: "bi-gift",
        roles: ['admin', 'operation', 'goods'],
        sub: [
          {
            heading: "box_categories",
            route: "/box_categories",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "box_infos",
            route: "/box_infos",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "box_records",
            route: "/box_records",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "gift_records",
            route: "/gift_records",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "run_gift_records",
            route: "/run_gift_records",
            roles: ['admin', 'operation']
          },
          {
            heading: "product_gift_records",
            route: "/product_gift_records",
            roles: ['admin', 'operation']
          }
        ]
      },

      // 3. 抽卡系统
      {
        sectionTitle: "card_draw_system",
        route: "/card_draw",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-collection",
        roles: ['admin', 'operation'],
        sub: [
          {
            heading: "card_series",
            route: "/card_series",
            roles: ['admin', 'operation']
          },
          {
            heading: "card_rarities",
            route: "/card_rarities",
            roles: ['admin', 'operation']
          },
          {
            heading: "card_languages",
            route: "/card_languages",
            roles: ['admin', 'operation']
          },
          {
            heading: "card_versions",
            route: "/card_versions",
            roles: ['admin', 'operation']
          },
          {
            heading: "cards_management",
            route: "/cards_management",
            roles: ['admin', 'operation']
          },
          {
            heading: "card_pools",
            route: "/card_pools",
            roles: ['admin', 'operation']
          },
          {
            heading: "card_draw_records",
            route: "/card_draw_records",
            roles: ['admin', 'operation']
          }
        ]
      },

      // 4. 对对碰系统
      {
        sectionTitle: "match_game_system",
        route: "/match_game",
        svgIcon: "media/icons/duotune/games/gam001.svg",
        fontIcon: "bi-grid-3x3-gap",
        roles: ['admin', 'operation'],
        sub: [
          {
            heading: "match_pools",
            route: "/match_pools",
            roles: ['admin', 'operation']
          },
          {
            heading: "match_game_records",
            route: "/match_game_records",
            roles: ['admin', 'operation']
          }
        ]
      },

      // 5. 明信片奖励
      {
        sectionTitle: "postcard_rewards",
        route: "/postcard_rewards",
        svgIcon: "media/icons/duotune/general/gen025.svg",
        fontIcon: "bi-postcard",
        roles: ['admin', 'operation'],
        sub: [
          {
            heading: "postcard_reward_configs",
            route: "/postcard_reward_configs",
            roles: ['admin', 'operation']
          },
          {
            heading: "postcard_reward_logs",
            route: "/postcard_reward_logs",
            roles: ['admin', 'operation']
          }
        ]
      },

      // 6. 商品中心
      {
        sectionTitle: "product_center",
        route: "/product",
        svgIcon: "media/icons/duotune/ecommerce/ecm005.svg",
        fontIcon: "bi-box-seam",
        roles: ['admin', 'operation', 'goods'],
        sub: [
          {
            heading: "products",
            route: "/products",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "product_brands",
            route: "/product_brands",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "ips",
            route: "/ips",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "compound_categories",
            route: "/compound_categories",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "compounds",
            route: "/compounds",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "compound_records",
            route: "/compounds/records",
            roles: ['admin', 'operation', 'goods']
          }
        ]
      },

      // 7. 商城管理
      {
        sectionTitle: "mall_management",
        route: "/mall",
        svgIcon: "media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-cart",
        roles: ['admin', 'operation', 'goods'],
        sub: [
          {
            heading: "mall_products",
            route: "/mall_products",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "mall_orders",
            route: "/mall_orders",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "mall_coupons",
            route: "/mall_coupons",
            roles: ['admin', 'operation']
          },
          {
            heading: "lottery_coupons",
            route: "/lottery_coupons",
            roles: ['admin', 'operation']
          },
          {
            heading: "lottery_signs",
            route: "/lottery_signs",
            roles: ['admin', 'operation']
          }
        ]
      },

      // 8. 发货管理
      {
        sectionTitle: "shipping_management",
        route: "/shipping",
        svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
        fontIcon: "bi-truck",
        roles: ['admin', 'goods'],
        sub: [
          {
            heading: "shipping_products",
            route: "/shipping_products",
            roles: ['admin', 'goods']
          },
          {
            heading: "shipping_records",
            route: "/shipping_records",
            roles: ['admin', 'goods']
          }
        ]
      },

      // 9. 用户管理
      {
        sectionTitle: "user_management",
        route: "/user",
        svgIcon: "media/icons/duotune/communication/com006.svg",
        fontIcon: "bi-people",
        roles: ['admin'],
        sub: [
          {
            heading: "members",
            route: "/user_members",
            roles: ['admin']
          },
          {
            heading: "pocket_items",
            route: "/user_pocket_items",
            roles: ['admin']
          }
        ]
      },

      // 10. 财务管理
      {
        sectionTitle: "finance_management",
        route: "/finance",
        svgIcon: "media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-cash-coin",
        roles: ['admin'],
        sub: [
          {
            heading: "payment_records",
            route: "/payment_records",
            roles: ['admin']
          },
          {
            heading: "add_balance_records",
            route: "/add_balance_records",
            roles: ['admin']
          },
          {
            heading: "充值追踪",
            route: "/payment_traces",
            roles: ['admin', 'operation']
          },
          {
            heading: "add_point_records",
            route: "/add_point_records",
            roles: ['admin']
          },
          {
            heading: "profit_records",
            route: "/profit_records",
            roles: ['admin']
          },
          {
            heading: "资产变动记录",
            route: "/change_logs",
            roles: ['admin']
          },
          {
            heading: "运营成本台账",
            route: "/operating_costs",
            roles: ['admin']
          }
        ]
      },

      // 11. 数据排名
      {
        sectionTitle: "data_rankings",
        route: "/rankings",
        svgIcon: "media/icons/duotune/graphs/gra002.svg",
        fontIcon: "bi-graph-up",
        roles: ['admin', 'operation', 'goods'],
        sub: [
          {
            heading: "water_items",
            route: "/water_items",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "loser_items",
            route: "/loser_items",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "asset_loser_items",
            route: "/asset_loser_items",
            roles: ['admin', 'operation']
          },
          {
            heading: "card_records",
            route: "/card_records",
            roles: ['admin', 'operation', 'goods']
          }
        ]
      },

      // 12. 系统设置
      {
        sectionTitle: "system_settings",
        route: "/settings",
        svgIcon: "media/icons/duotune/general/gen019.svg",
        fontIcon: "bi-gear",
        roles: ['admin', 'operation'],
        sub: [
          {
            heading: "banners",
            route: "/banners",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "events",
            route: "/events",
            roles: ['admin', 'operation', 'goods']
          },
          {
            heading: "deliver_note",
            route: "/system_settings/deliver_note",
            roles: ['admin', 'operation']
          },
          {
            heading: "shipping_fee_config",
            route: "/system_settings/shipping_fee_config",
            roles: ['admin']
          },
          {
            heading: "settlement_pause",
            route: "/system_settings/settlement_pause",
            roles: ['admin']
          },
          {
            heading: "excluded_gain_categories",
            route: "/system_settings/excluded_gain_categories",
            roles: ['admin']
          },
          {
            heading: "eat_cook_categories",
            route: "/system_settings/eat_cook_categories",
            roles: ['admin']
          },
          {
            heading: "admins",
            route: "/admins",
            roles: ['admin']
          },
          {
            heading: "distributions",
            route: "/distributions",
            roles: ['admin']
          }
        ]
      },
    ],
  },
];

export default DocMenuConfig;
